module.exports = __webpack_public_path__ + "img/color_platinum_a-2130-1@2x.31eba1b.jpg";